// Convert string to number, if NaN return undefined
export const parseNumber = (value: string): number | undefined => {
  const parsed = Number(value);
  return isNaN(parsed) ? undefined : parsed;
};
